import { render, staticRenderFns } from "./tourRoute.vue?vue&type=template&id=80e496ae&scoped=true&"
import script from "./tourRoute.vue?vue&type=script&lang=js&"
export * from "./tourRoute.vue?vue&type=script&lang=js&"
import style0 from "./tourRoute.vue?vue&type=style&index=0&id=80e496ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e496ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VDataTable,VForm,VIcon,VSelect,VTabItem,VTabsItems})
